export default __webpack_public_path__ + "static/media/thematter.7f885091.svg";